import React from 'react'
import WaveImg from "../../assets/wave.png";

const Wave = () => {
  return (
    <img src={WaveImg} width="100%" height="100%" alt="wave" />
  )
}

export default Wave